import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ArrowRight } from "@phosphor-icons/react/ArrowRight";
import { paths } from "config/paths";
import { MapField, mapPalettes } from "mangomap-ui/src/components/map-field";
import { headingFontFamily } from "../heading-font";

export function StartBuilding() {
	const cta = {
		heading: "For GIS teams who outgrew the enterprise pricing model. ",
		subHeading:
			"Publish, share, and manage maps without consumption credits, seat minimums, or surprise invoices. The money stays where the work is.",
		ctaButton: "Get started",
		image: "/app-assets/home-howitworks.jpg",
	};

	return (
		<Box sx={{ pb: "60px" }}>
			<Container>
				<Box
					sx={{
						border: "1px solid transparent",
						borderRadius: "20px",
						color: "var(--mui-palette-common-white)",
						display: "flex",
						flexDirection: { xs: "column", md: "row" },
						overflow: "hidden",
						position: "relative",
					}}>
					<Box
						sx={{
							bgcolor: "var(--mui-palette-neutral-950)",
							borderRadius: "20px",
							bottom: "1px",
							left: "-1px",
							position: "absolute",
							right: 0,
							top: "-1px",
							zIndex: 0,
						}}>
						<MapField
							seed="start-building-pricing"
							variant="parcels"
							strokeWidth={0.5}
							parcelMinSize={0.5}
							parcelMaxDepth={13}
							aspect="16 / 9"
							animate
							duration={5}
							palette={mapPalettes.onDark}
							style={{ width: "100%", height: "100%", opacity: 0.2 }}
						/>
					</Box>
					<Stack
						spacing={3}
						sx={{
							flex: "0 1 auto",
							position: "relative",
							px: "64px",
							py: "64px",
							width: { xs: "100%", md: "45%" },
							zIndex: 1,
						}}>
						<Stack spacing={2}>
							<Typography
								color="inherit"
								sx={{ fontFamily: headingFontFamily }}
								variant="h4">
								{cta.heading}
							</Typography>
							<Typography color="neutral.300">{cta.subHeading}</Typography>
						</Stack>
						<div>
							<Button
								endIcon={<ArrowRight />}
								href={paths.signUp}
								size="large"
								target="_blank"
								variant="contained">
								{cta.ctaButton}
							</Button>
						</div>
					</Stack>
					<Box
						sx={{
							alignItems: { xs: "flex-end", md: "stretch" },
							borderRadius: "20px",
							display: "flex",
							flex: "1 1 auto",
							flexDirection: "column",
							justifyContent: "flex-end",
							pl: { xs: 0, md: 0 },
							position: "relative",
							zIndex: 2,
						}}>
						<Box
							sx={{
								height: { xs: "300px", md: "340px" },
								overflow: "hidden",
								position: "relative",
								width: "100%",
							}}>
							<Box
								sx={{
									height: "100%",
									position: "relative",
									width: "100%",
									zIndex: 1,
								}}>
								<Box
									component="img"
									src={cta.image}
									sx={{
										borderRadius: { xs: "0", md: "40px 0 0 0" },
										display: "block",
										height: "100%",
										inset: 0,
										objectFit: "cover",
										position: "absolute",
										width: "100%",
									}}
								/>
							</Box>
						</Box>
					</Box>
				</Box>
			</Container>
		</Box>
	);
}
